export const deleteUserWorkspaceSchema = {
  body: {
    type: "object",
    properties: { userId: { type: "number" } },
    required: ["userId"],
  },
};

// API: sysAdmin-only direct membership grant by user id, for automated setup
// where nothing can read an inbox (see createWorkspaceInvitationSchema).
export const addWorkspaceMemberSchema = {
  body: {
    type: "object",
    properties: { userId: { type: "number" } },
    required: ["userId"],
  },
};

export const createWorkspaceSchema = {
  body: {
    type: "object",
    properties: { name: { type: "string", minLength: 1 } },
    required: ["name"],
  },
};

export const deleteWorkspaceSchema = {
  body: {
    type: "object",
    properties: { id: { type: "number" } },
    required: ["id"],
  },
};

export const web_workspaceSchema = {
  type: "object",
  properties: {
    name: { type: "string", minLength: 1 },
  },
  required: ["name"],
};

// API: owner/sysAdmin invites a person by email. An address with a Congrs
// account is added to the workspace on the spot; one without gets an emailed
// invitation to create an account. `sendEmail: false` (sysAdmin only, the
// service enforces it) adds or records the invitation without emailing.
export const createWorkspaceInvitationSchema = {
  body: {
    type: "object",
    properties: {
      email: { type: "string", format: "email", minLength: 1 },
      sendEmail: { type: "boolean", default: true },
    },
    required: ["email"],
  },
};

// API: owner/sysAdmin checks who is behind an email before adding it, so the
// invite form can show the matched account and ask for confirmation.
export const lookupWorkspaceAccountSchema = {
  querystring: {
    type: "object",
    properties: {
      email: { type: "string", format: "email", minLength: 1 },
    },
    required: ["email"],
  },
};

// API: public accept. The invitation token only ever creates an account, so a
// credential — a password, a Google ID token, or an Apple ID token — is needed
// exactly when the invited email has no account yet; the service enforces
// that, along with `firstName`/`lastName` when the provider does not supply
// them. An email that already has an account is added with an empty body.
export const acceptWorkspaceInvitationSchema = {
  body: {
    type: "object",
    properties: {
      password: { type: "string", minLength: 1 },
      firstName: { type: "string" },
      lastName: { type: "string" },
      // Raw JWT, or the credential object from @react-oauth/google.
      google: {
        anyOf: [
          { type: "string", minLength: 1 },
          {
            type: "object",
            properties: {
              credential: { type: "string", minLength: 1 },
              clientId: { type: "string" },
            },
            required: ["credential"],
          },
        ],
      },
      apple: {
        type: "object",
        properties: {
          id_token: { type: "string", minLength: 1 },
          isMobile: { type: "boolean", default: false },
        },
        required: ["id_token"],
      },
    },
  },
};

// Web: invite-by-email form.
export const web_inviteToWorkspaceSchema = {
  type: "object",
  properties: {
    email: { type: "string", format: "email", minLength: 1 },
  },
  required: ["email"],
  errorMessage: {
    properties: {
      email: "Please enter a valid email address",
    },
  },
};

// Web: accept invitation by creating a new account.
export const web_acceptInviteCreateAccountSchema = {
  type: "object",
  properties: {
    firstName: { type: "string", minLength: 1 },
    lastName: { type: "string", minLength: 1 },
    password: {
      type: "string",
      minLength: 3,
      pattern: "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).{8,}$",
    },
    confirmPassword: {
      type: "string",
      const: { $data: "1/password" },
    },
  },
  required: ["firstName", "lastName", "password", "confirmPassword"],
  errorMessage: {
    properties: {
      firstName: "First name is required",
      lastName: "Last name is required",
      password:
        "Password must contain at least 8 characters, a lowercase, an uppercase, and a digit",
      confirmPassword: "Passwords do not match",
    },
  },
};
